import React from "react";
import { GridLoader } from "react-spinners";

const CallWait = (props) => {
  const { message, description } = props;

  return (
    <div className='d-flex align-items-center flex-column vh-100 justify-content-center text-center py-3'>
      <div className='d-flex align-items-center flex-column px-4'>
        <GridLoader color={"#AE101D"} loading={true} />
      </div>
      <div className='font-size-xl text-center pt-4'>
        {message}
        <span className='text-muted font-size-lg d-block text-dark'>{description}</span>
      </div>
    </div>
  );
};

export default CallWait;
